<ul style="border: 2px solid #959697;max-height: 300px;overflow-y: scroll;">
  <li *ngFor="let item of DataList_DeviceGroup_Parent" style="list-style: none;" >
    <span >{{item.title}}</span>

    <ul style="border-right: dotted" >
      <li  style="margin-right: 50px;list-style: none;" *ngFor="let itemDetail of item.child">
        <input  type="checkbox" (click)="OnChangeSelect_DeviceGroup(itemDetail)" [checked]="itemDetail.del" class="Lvl2" />  <span >{{itemDetail.title}}</span>
     </li>
    </ul>

 </li>
</ul>
